import { UseFormPayload } from '@domain-group/react-hooks'
import { Form, SectionDivider } from '@domain-group/suit-theme'

interface PropertyDetailsProps {
  campaignComparableFormPayload: UseFormPayload,
}

const PricingAndSale = (props: PropertyDetailsProps) => {
  const { campaignComparableFormPayload } = props

  const {
    entityState: {
      price_guide,
      sold,
      sold_date,
      sale_method,
    },
    errors,
    handlers,
  } = campaignComparableFormPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>Pricing & Sale</SectionDivider>

      <Form.Field label="* Price Guide" errorMessage={errors.price_guide} marginTop="large">
        <input name="price_guide" type="text" value={price_guide} {...handlers} />
      </Form.Field>

      <Form.Row>
        <Form.Field label="Property Sold?" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="sold" value={sold} {...handlers} data-value-type="boolean">
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </Form.Field>

        <Form.Field label="Rental" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="data.sale_method" value={sale_method} {...handlers}>
            <option value="">No</option>
            <option value="rental">Yes</option>
          </select>
        </Form.Field>
      </Form.Row>

      {sold && (
        <Form.Field label="Sold Date" marginTop="large">
          <input type="date" name="sold_date" value={sold_date} {...handlers} />
        </Form.Field>
      )}
    </>
  )
}

export default PricingAndSale
